<ng-container *ngIf="showLabel">
  <label class="label-font" >
    <span>{{ dropdownLabel }}
      <span *ngIf="isRequired" class="required-star">*</span>
    </span>
    
    <i 
      *ngIf="showInfoIcon"
      class="info-icon {{ infoIconClass }}"
      style="margin-left: 0.75rem;"
      [pTooltip]="infoTooltip"
      [tooltipPosition]="infoTooltipPosition"
      tooltipEvent="hover"
      aria-label="More info"
      tabindex="0">
    </i>

  </label>
  
  <br />
</ng-container>
<p-dropdown  
 class="custom-dropdown"
 [autoDisplayFirst]="false"
 [options]="options"
 [pTooltip]="errorMessage ? errorMessage : (showTooltip ? 'Please fill this field' : '')"
 tooltipPosition="top"
 [disabled]="isDisabled"
 [filter]="filter" 
 [ngStyle]="{'--dropdown-border-color': (showError ? 'red' : '#989898') }"
 filterBy="name"
 [showClear]="showClear"
 [options]="loading ? [] : options"
 [virtualScroll]="virtualScroll" 
 [virtualScrollItemSize]="virtualScrollItemSize"
 [optionLabel]="optionLabel"
 [optionValue]="optionValue"
 [ngModel]="selectedOption" 
 [placeholder]="placeholder"
 (onChange)="onChange($event)"
 autoWidth="false"
 [style]="customStyle"
 appendTo="body"
 [id]="id"
 #dropdownPanel
 >
 
 
  <ng-template pTemplate="empty">
    <div *ngIf="loading" class="dropdown-skeleton">
      <div class="skeleton-line" style="width: 85%; height: 20px; margin: 5px 0; background: #eee; animation: pulse 1.5s infinite;"></div>
      <div class="skeleton-line" style="width: 85%; height: 20px; margin: 5px 0; background: #eee; animation: pulse 1.5s infinite;"></div>
      <div class="skeleton-line" style="width: 85%; height: 20px; margin: 5px 0; background: #eee; animation: pulse 1.5s infinite;"></div>
    </div>
    <div *ngIf="!loading" class="no-results">No results found.</div>
  </ng-template>

  <ng-template let-item pTemplate="item" *ngIf="!loading">
    <div class='custom-dropdown-item'>{{item[optionLabel]}}</div>
  </ng-template>
</p-dropdown>
